module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-16-19.164Z.4cc45860.png";